
const defaultState = {
    resetviewPopup: false,// Toggle_On
    alertPasswordExp: false,//Alert_On
}

const resetPwdReducer = (state=defaultState, action) =>{
    if(action.type == "Toggle_On"){
        return state = {...state,...action.payload}
    }else 
    if(action.type == "Toggle_Off"){
        return state = {...state,...defaultState}
    }else 
    if(action.type == "Alert_On"){
        return state = {...state,...action.payload}
    }else 
    if(action.type == "Alert_Off"){
        return state = {...state,...defaultState}
    }
    return state;
}

export default resetPwdReducer;